import {Translate, I18n} from 'react-redux-i18n';
import moment from 'moment-timezone';
import {status} from '../../../utils/constant';
import {interventionPropTypes} from '../../../utils/propTypes';

export function ProjectTreeRowRole(props) {
  const {intervention} = props;
  const isRejected = intervention.status === status.REJECTED;
  const isPending = intervention.status === status.PENDING;
  const isEnded = intervention.status === status.ENDED;
  const isOrganisationDeactivated = !intervention.organisation.enabled;

  const getRejectionReason = () => (intervention.rejectionReason ?
    `rejectionReason.reason.${intervention.rejectionReason.toUpperCase()}` :
    'rejectionReason.reason.NO_REASON_GIVEN');

  const getPendingMessage = () => `intervention.invited.${intervention.invitationId ? 'external' : 'internal'}.${intervention.role}`;

  const getRensentDate = () => {
    if (isPending && intervention.lastSentDate && !moment(intervention.creationDate).isSame(intervention.lastSentDate, 'days')) {
      return <Translate
        value="invitation.sent.resentOn"
        date={I18n.l(intervention.lastSentDate, {dateFormat: 'datetime.shortDate'})}
        tag="div"
      />;
    }

    return false;
  };

  return (
    <div>
      <Translate
        value={`intervention.role.${intervention.role}`}
        tag="div"
      />
      <div className="information">
        {isRejected &&
          <>
            <Translate
              value="rejectionReason.displayLabel"
              tag="div"
            />
            <Translate
              value={getRejectionReason()}
              tag="div"
            />
          </>
        }
        {isPending &&
          <Translate
            value={getPendingMessage()}
            tag="div"
          />
        }
        {isEnded &&
          <Translate
            value="intervention.ended.name"
            tag="div"
          />
        }
        {isOrganisationDeactivated &&
          <Translate
            value="intervention.organisationDeactivated"
            tag="div"
          />
        }
        {getRensentDate()}
      </div>
    </div>
  );
}

ProjectTreeRowRole.propTypes = {
  intervention: interventionPropTypes().isRequired
};

export default ProjectTreeRowRole;
